import React, { Fragment } from 'react';
import { inject, observer } from 'mobx-react';

import FIELD_KEY_MAP from './field-key-map';

@inject('formStore')
@observer
class PasswordInfo extends React.Component {
	render () {
		const { formStore, isPasswordBox} = this.props;
		const passwordValid = formStore.validation[FIELD_KEY_MAP.password];
		const passwordsMatch = formStore.validation[FIELD_KEY_MAP.confirmPassword];
		
		return (
			<Fragment>
				{(passwordValid && isPasswordBox) && ( 
					<div data-rh='' style={{position:'absolute', top: '50%', right: '-10%'}}>
						<i 
							className="fas fa-question-circle" 
							style={{color:"#09be31"}}
						/>
					</div>
				)}
				{(!passwordValid && isPasswordBox) && ( 
					<div data-rh='' style={{position:'absolute', top: '50%', right: '-10%'}}>
						<i 
							className="fas fa-question-circle" 
							style={{color: "#ea0000"}}
						/>
					</div>
				)}
				{(passwordsMatch && !isPasswordBox) && ( 
					<div data-rh='Passwords match!' style={{position:'absolute', top: '50%', right: '-10%'}}>
						<i 
							className="fas fa-check-circle" 
							style={{color:"#09be31"}}
						/>
					</div>
				)}
				{(!passwordsMatch && !isPasswordBox) && ( 
					<div data-rh='Passwords do not match.' style={{position:'absolute', top: '50%', right: '-10%'}}>
						<i 
							className="fas fa-check-circle" 
							style={{color:"#ea0000"}}
						/>
					</div>
				)}
			</Fragment>
		)
	}
}

export default PasswordInfo;
